import React, { Component } from 'react';
import {Table, Checkbox, ButtonToolbar, Button, Glyphicon, Image} from 'react-bootstrap';
import { DEFAULT_PAGE_NUM, EMPTY_COUNT, FIELD_CHECKBOX_INDETERMINATE, EMPTY_STRING } from '../../utils/constants';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { adjustTables } from '../../includes/custom/js/tableScript';

class ContainerTableTemplate extends Component {

	constructor(props) {
        super(props);
        this.state = {
            idColumns: []
        };
    }


	TableHeader = () =>{
		return this.props.tableHeader && this.props.tableHeader.map((header, index) => {
			let headClass = "head" + index;

			let fixedHeaderClass = index === (this.props.tableHeader.length - DEFAULT_PAGE_NUM) ? "fixed-header lasthead" : "fixed-header";
			fixedHeaderClass += (header.center) ? " text-center" : ""
			fixedHeaderClass += (header.required) ? " required-input" : ""

			if (header.button) {
				return (<th key={index} className={fixedHeaderClass + " table-button-header"} id={headClass}><center>{header.label.split ('\n').map ((item, i) => <div key={i}>{item}<br/></div>)}</center></th>);
			} else if (header.checkbox) {
				return (<th key={index} className={fixedHeaderClass + " table-checkbox-header"} id={headClass}>
					{this.renderMainCheckbox(header.label)}
				</th>
				);
			} else if (header.id) {
				this.setState({idColumns: this.state.idColumns.push(index)});
				return (<th key={index} className={fixedHeaderClass + " table-id"} id={headClass}>{header.label.split ('\n').map ((item, i) => <div key={i}>{item}<br/></div>)}</th>);
			} else {
				return (<th key={index} className={fixedHeaderClass} id={headClass}>{header.label}</th>);
			}
		});
	}

	renderMainCheckbox = (label) =>{
        let hasSelected = EMPTY_COUNT < this.props.checkboxItems.length && this.props.tableList.length >= this.props.checkboxItems.length;

        return (
            <Checkbox
                id={FIELD_CHECKBOX_INDETERMINATE}
                checked={hasSelected}
                onChange={this.props.handleMainCheckboxChange.bind(this, hasSelected)}
                onClick={this.props.handleMainCheckboxChange.bind(this, hasSelected)}
                className="header-checklist"
            >
                {label}
            </Checkbox>
        )

    }
	
 	rowStyle = (row) => {
        let style = {}
        if (this.props.specialRow) {
            if (this.props.specialRow.notEqual) {
                if (row[this.props.specialRow.field] !== this.props.specialRow.value) {
                    style = { backgroundColor: this.props.specialRow.color }
                }
            } else if (this.props.specialRow.greaterThan) {
                if (row[this.props.specialRow.field] > this.props.specialRow.value) {
                    style = { backgroundColor: this.props.specialRow.color }
                }
            } else if (row[this.props.specialRow.field] === this.props.specialRow.value) {
                style = { backgroundColor: this.props.specialRow.color }
            }
        }

        return style
	}

	RenderRow = (data, rowIndex) => {

        let rightAlignStyle = { textAlign: "right", paddingRight: "8px" };

        return (
            this.props.tableColumns.map((column, i) => {
				let colClass = "col" + i;
				
                return (
                    <td
                        key={i}
                        id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING}
                        className={EMPTY_COUNT <= this.state.idColumns.indexOf(i) ? ["table-id", this.props.tableHeader[i].headerClass] : this.props.tableHeader[i].headerClass}
                        style={this.props.tableHeader[i].rightAlign && rightAlignStyle}
                    >
                        <div className={this.props.tableHeader[i].contentClass}>
                            {data[column]}
                        </div>
                    </td>
				);
			})
        );
    }
	
	RenderButtons = (data, rowIndex) =>{
        const rowButtonStyle = {
            display: "flex",
            justifyContent: "center",
            marginLeft: "5px",

        };
        const buttonStyle = {
            marginTop: "0px"
        };

        return (
            this.props.rowButtons.map((button, i) => {
                let colClass = "col" + (this.props.tableHeader.length - this.props.rowButtons.length + i);
                return (
                    <td key={i} id={EMPTY_COUNT === rowIndex ? colClass : EMPTY_STRING} className="table-button-header">
                        <ButtonToolbar style={rowButtonStyle}>
                            <Button
                                key={i}
                                style={buttonStyle}
                                bsStyle={button.bsStyle}
                                onClick={button.onClick.bind(this, data)}
                                disabled={this.props.isDisabled}
                            >
                                {button.icon && <FontAwesomeIcon icon={button.icon} size="2x" color="#000" />}
                                {button.glyph && <Glyphicon glyph={button.glyph} />}
                                {button.img && <Image src={button.img} alt="button-icon" className="img-icon" />}
                                {' '}
                                {button.label}
                            </Button>

                        </ButtonToolbar>
                    </td>
                )
            })
        )
	}
	
	TableList = () =>{
		return this.props.tableList && EMPTY_COUNT < this.props.tableList.length ? (
			this.props.tableList.map((row, i) => {
				return (
					<tr key={i} style={this.rowStyle(row)} >
						{this.RenderRow(row, i)}
						{this.props.rowButtons ? this.RenderButtons(row, i) : null}
					</tr>
				);

			})
		) : <tr><td className="col-center" colSpan={this.props.tableHeader.length}>表示するデータがありません。</td></tr>
	}

    shouldComponentUpdate() {
        return this.props.rerender;
    }

    render() {
		let tableClassName = this.props.tableName ? this.props.tableName : "defaultTable";
		adjustTables(tableClassName);
		
        return (
            <div className={tableClassName}>
            <div className={"thead-fixed table-responsive " + tableClassName}>
                <Table condensed hover bordered>
                    <thead className="table-header">
                        <tr>{this.TableHeader()}</tr>
                    </thead>
                </Table>
            </div>

            <div className={"tbody-fixed table-responsive " + tableClassName} id={tableClassName}>
                <Table condensed hover striped bordered>
                    <tbody className="default-tbody">
                        {this.TableList()}
                    </tbody>
                </Table>
            </div>
        </div>
        )
    }
}
export default ContainerTableTemplate;